import { __ } from '@wordpress/i18n';

const Table = ({
    columns,        // [{ key: 'name', label: 'Group Name' }, ...]
    data,           // array of objects
    renderRow,      // function(rowData) => JSX for <tr>
    emptyMessage,   // string for empty table
    className = '',
    style = {}
}) => {
    return (
        <div className={`voxycure-card voxycure-table-wrapper ${className}`} style={style}>
            <table className="voxycure-table">
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th key={col.key}>
                                {col.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.length === 0 ? (
                        <tr>
                            <td colSpan={columns.length} style={{ padding: '1rem', textAlign: 'center', color: '#666' }}>
                                {emptyMessage || __('No data found.', 'voxycure-framework')}
                            </td>
                        </tr>
                    ) : (
                        data.map((row, index) => renderRow(row, index))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default Table;
